<template>
  <div class="divisions">
    <div class="division" v-if="team.division">
      <span class="label">
        DIVISION
      </span>
      <div class="color-bar first">
        <span class="text">
          {{team.division.name}}
        </span>
        <span class="arrow"></span>
      </div>
    </div>

    <div class="division" v-if="team.secondDivision">
      <span class="label">
        2ND DIVISION
      </span>
      <div class="color-bar second">
        <span class="text">
          {{team.secondDivision.name}}
        </span>
        <span class="arrow"></span>
      </div>
    </div>

    <div class="division" v-if="team.movingFlight">
      <span class="label">
        MOVING WEEK
      </span>
      <div class="color-bar third">
        <span class="text">
          {{team.movingFlight.name}}
        </span>
        <span class="arrow"></span>
      </div>
    </div>

    <div class="division" v-if="team.flight">
      <span class="label">
        FINAL FLIGHT
      </span>
      <div class="color-bar fourth">
        <span class="text">
          {{team.flight.name}}
        </span>
        <span class="arrow"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    team: Object,
  },
};
</script>
<style lang="scss" scoped>
  .divisions {
    display: flex;
  }
  .division {
    &:first-child {
      .color-bar {
        padding-left: .75rem;
        border-radius: 5px 0 0 5px;
      }
      .label {
        padding-left: 0;
      }
    }
    &:last-child {
      .color-bar {
        padding-right: .75rem;
        border-radius: 0 5px 5px 0;
        .arrow {
          display: none;
        }
      }
    }
    &:only-child {
      .color-bar {
        padding-right: .75rem;
        border-radius: 5px;
        padding-left: .75rem;
      }
    }
    .label {
      font-weight: bold;
      opacity: 0.7;
      padding-right: .75rem;
      font-size: .7rem;
    }
  }
  .color-bar {
    background: blue;
    color: white;
    height: 2rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 1.5rem;
    padding-right: .5rem;

    .arrow {
      display: block;
      width: 0;
      height: 0;
      border-top: 1rem solid transparent;
      border-left-style: solid;
      border-left-width: 1rem;
      border-bottom: 1rem solid transparent;
      position: absolute;
      top: 0;
      right: -1rem;
      z-index: 999;
    }
  }
  .first {
    background: #1172EE;
    .arrow {
      border-left-color: #1172EE;
    }
  }
  .second {
    background: #1189EF;
    .arrow {
      border-left-color: #1189EF;
    }
  }
  .third {
    background: #11A1EF;
    .arrow {
      border-left-color: #11A1EF;
    }
  }
  .fourth {
    background: #11B7EF;
    .arrow {
      border-left-color: #11B7EF;
    }
  }
</style>
